import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Storage } from '@ionic/storage';
import { DialogData } from 'src/app/common/delete-alert/delete-alert.component';
import { DataService } from 'src/app/service/data.service';

@Component({
  selector: 'app-matrix-selection',
  templateUrl: './matrix-selection.component.html',
  styleUrls: ['./matrix-selection.component.scss']
})
export class MatrixSelectionComponent implements OnInit {
  loadingTrue = true;
  btnClicked = false;
  responseData: any;
  items: any = [];
  displayedColumns = [];
  branchmatrix = '';
  totalstock = '';
  matrixcaption = {
    matrix1: {
      required: '',
      caption: '',
    },
    matrix2: {
      required: '',
      caption: '',
    },
    matrix3: {
      required: '',
      caption: '',
    },
    matrix4: {
      required: '',
      caption: '',
    },
    matrix5: {
      required: '',
      caption: '',
    },
    matrix6: {
      required: '',
      caption: '',
    },
    matrix7: {
      required: '',
      caption: '',
    },
    matrix8: {
      required: '',
      caption: '',
    },
    matrix9: {
      required: '',
      caption: '',
    },
    matrix10: {
      required: '',
      caption: '',
    }
  }
  itemDetails = {
    matrix1code: '',
    matrix2code: '',
    matrix3code: '',
    matrix4code: '',
    matrix5code: '',
    matrix6code: '',
    matrix7code: '',
    matrix8code: '',
    matrix9code: '',
    matrix10code: '',
    branchcodes: [],
    serialdetails: {
      reffield2: {
        required: '',
        mandatory: ''
      },
      reffield3: {
        required: '',
        mandatory: ''
      },
      reffield4: {
        required: '',
        mandatory: ''
      },
      reffield5: {
        required: '',
        mandatory: ''
      },
      reffield6: {
        required: '',
        mandatory: ''
      },
      reffield7: {
        required: '',
        mandatory: ''
      },
      reffield8: {
        required: '',
        mandatory: ''
      },
      reffield9: {
        required: '',
        mandatory: ''
      },
      reffield10: {
        required: '',
        mandatory: ''
      },
      reffielddisplaycolumns: []
    },
    matrixsetup: {
      matrix1: {
        required: ''
      },
      matrix2: {
        required: ''
      },
      matrix3: {
        required: ''
      },
      matrix4: {
        required: ''
      },
      matrix5: {
        required: ''
      },
      matrix6: {
        required: ''
      },
      matrix7: {
        required: ''
      },
      matrix8: {
        required: ''
      },
      matrix9: {
        required: ''
      },
      matrix10: {
        required: ''
      },
      matrixheaddisplaycolumns: [],
      matrixnamedisplaycolumns: []
    },
    branchwiseminmaxstocks: [],
    branchwisemrpdiscounts: [],
    branchwisepricing: [],
    branchwiseproducts: [],
    multibarcodes: [],
    quantitypricesetup: {
      qtywisepricing: []
    },
    margindetails: {
      mrpmargindetails: {
        mrpdisc1per: '',
        mrpdisc2per: '',
        mrpmargin: '',
        mrpmarkupper: '',
        mrpmarkdownper: '',
        mrpnetmargin: '',
        mrpnetmarginper: ''
      },
      purchasedetails: {
        prdiscper: '',
        prtaxvalue: '',
        prwithtax: ''
      },
      salesmargindetails: {
        srdiscper: '',
        srwithouttax: '',
        srtaxvalue: '',
        srmargin: '',
        srmarkupper: '',
        srmarkdownper: '',
        srnetmargin: '',
        srnetmarginper: ''
      },
      priceschemes: {
        dlrpdiscper: '',
        dlrpmarginper: '',
        dlrpmarginvalue: '',
        p1discper: '',
        p1marginper: '',
        p1marginvalue: '',
        p2discper: '',
        p2marginper: '',
        p2marginvalue: '',
        p3discper: '',
        p3marginper: '',
        p3marginvalue: '',
        p4discper: '',
        p4marginper: '',
        p4marginvalue: '',
        p5discper: '',
        p5marginper: '',
        p5marginvalue: '',
        p6discper: '',
        p6marginper: '',
        p6marginvalue: ''
      },
      roundoffnetvalues: ''
    },

    ic: '',
    ina: '',
    refn: '',
    sr: '',
    tp: '',
    cc: '',
    dp: '',
    da: '',
    unit: '',
    itemactive: '',
    reftype: '',
    stkchk: '',
    hsncode: '',
    taxcode: '',
    sq: '',
    fd: '',
    uomcode: '',
    subuomcode: '',
    mpchk: '',
    pr: '',
    mrp: '',
    dlrp: '',
    bc: '',
    bcm: '',
    pcm: '',
    p1: '',
    p2: '',
    p3: '',
    p4: '',
    p5: '',
    p6: '',
    d1: '',
    d2: '',
    d3: '',
    d4: '',
    d5: '',
    d6: '',
    netwt: '',
    grswt: '',
    imc: '',
    ilc: '',
    origincode: '',
    onlineallowed: '',
    mfgdateyn: '',
    expdays: '',
    cc2: '',
    cc3: '',
    cc4: '',
    cc5: '',
    itemtypecode: '',
    cesspercent: '',
    extracessrate: ''
  };
  singleselect = {
    matrix1code: '',
    matrix2code: '',
    matrix3code: '',
    matrix4code: '',
    matrix5code: '',
    matrix6code: '',
    matrix7code: '',
    matrix8code: '',
    matrix9code: '',
    matrix10code: '',
  };
  stockrequest = '';
  constructor(
    public dialogRef: MatDialogRef<MatrixSelectionComponent>,
    @Inject(MAT_DIALOG_DATA) public xdata: DialogData,
    public data: DataService,
    public storage: Storage
  ) {
    this.responseData = this.xdata;
    this.itemDetails = this.responseData;
    this.stockrequest = this.responseData.stockrequest;
    this.branchmatrix = this.responseData.branchmatrix;
  }

  ngOnInit(): void {
    this.setDisplayColumn();
    this.getMatrixName(true);
    if (this.branchmatrix === 'YES') {
      this.updateMatrixSelect(true);
    }
  }

  setDisplayColumn() {
    this.displayedColumns = [];
    if (this.itemDetails.matrixsetup.matrix1.required === 'YES') {
      this.displayedColumns.push('matrix1name');
    }
    if (this.itemDetails.matrixsetup.matrix2.required === 'YES') {
      this.displayedColumns.push('matrix2name');
    }
    if (this.itemDetails.matrixsetup.matrix3.required === 'YES') {
      this.displayedColumns.push('matrix3name');
    }
    if (this.itemDetails.matrixsetup.matrix4.required === 'YES') {
      this.displayedColumns.push('matrix4name');
    }
    if (this.itemDetails.matrixsetup.matrix5.required === 'YES') {
      this.displayedColumns.push('matrix5name');
    }
    if (this.itemDetails.matrixsetup.matrix6.required === 'YES') {
      this.displayedColumns.push('matrix6name');
    }
    if (this.itemDetails.matrixsetup.matrix7.required === 'YES') {
      this.displayedColumns.push('matrix7name');
    }
    if (this.itemDetails.matrixsetup.matrix8.required === 'YES') {
      this.displayedColumns.push('matrix8name');
    }
    if (this.itemDetails.matrixsetup.matrix9.required === 'YES') {
      this.displayedColumns.push('matrix9name');
    }
    if (this.itemDetails.matrixsetup.matrix10.required === 'YES') {
      this.displayedColumns.push('matrix10name');
    }
    this.displayedColumns.push('stock');
    if (this.branchmatrix === 'YES') {
    this.displayedColumns.push('branchname');
    }
  }

  updateMatrixSelect(val) {
    if (this.branchmatrix === 'YES') {
      const obj = {
        ic: this.itemDetails.ic,
        matrix1code: this.itemDetails.matrix1code,
        matrix2code: this.itemDetails.matrix2code,
        matrix3code: this.itemDetails.matrix3code,
        matrix4code: this.itemDetails.matrix4code,
        matrix5code: this.itemDetails.matrix5code,
        matrix6code: this.itemDetails.matrix6code,
        matrix7code: this.itemDetails.matrix7code,
        matrix8code: this.itemDetails.matrix8code,
        matrix9code: this.itemDetails.matrix9code,
        matrix10code: this.itemDetails.matrix10code,
        searchitem: '',
        searchmatrixhead: val,
        branchcodes: this.itemDetails.branchcodes
      };
      this.loadingTrue = val;
      this.data.postData('matrixstocks/branchwise', obj).then((success) => {
        this.responseData = success;
        if (this.responseData.Status === true) {
          this.items = new MatTableDataSource(this.responseData.data);
          this.totalstock = this.responseData.totalstocks;
        } else {
          this.items = [];
        }
        this.loadingTrue = false;
      }, (error) => {
        this.data.errorResponse(error);
      });
    } else {
      const obj = {
        ic: this.itemDetails.ic,
        matrix1code: this.itemDetails.matrix1code,
        matrix2code: this.itemDetails.matrix2code,
        matrix3code: this.itemDetails.matrix3code,
        matrix4code: this.itemDetails.matrix4code,
        matrix5code: this.itemDetails.matrix5code,
        matrix6code: this.itemDetails.matrix6code,
        matrix7code: this.itemDetails.matrix7code,
        matrix8code: this.itemDetails.matrix8code,
        matrix9code: this.itemDetails.matrix9code,
        matrix10code: this.itemDetails.matrix10code,
        searchitem: '',
        searchmatrixhead: val
      };
      this.loadingTrue = val;
      this.data.postData('search/matrixstocks/allinone', obj).then((success) => {
        this.responseData = success;
        if (this.responseData.Status === true) {
          this.items = new MatTableDataSource(this.responseData.data);
        } else {
          this.items = [];
        }
        this.loadingTrue = false;
      }, (error) => {
        this.data.errorResponse(error);
      });
    }
  }

  getMatrixName(val) {
    if (this.data.token !== '') {
      this.loadingTrue = val;
      this.data.getData('matrix/setup').then((success) => {
        this.responseData = success;
        this.loadingTrue = false;
        if (this.responseData.Status === true) {
          this.matrixcaption = this.responseData.data;
        } else {
        }
      }, (error) => {
        this.loadingTrue = false;
        this.data.errorResponse(error);
      });
    } else {
      setTimeout(() => {
        this.getMatrixName(true);
      }, 400);
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  goNext(): void {
    this.dialogRef.close({
      selectedbill: this.singleselect,
    });
  }

  select(val) {
    this.singleselect = val;
    this.goNext();
  }

  matrixSelected(val) {
    this.itemDetails.matrix1code = val.matrix1code;
    this.itemDetails.matrix2code = val.matrix2code;
    this.itemDetails.matrix3code = val.matrix3code;
    this.itemDetails.matrix4code = val.matrix4code;
    this.itemDetails.matrix5code = val.matrix5code;
    this.itemDetails.matrix6code = val.matrix6code;
    this.itemDetails.matrix7code = val.matrix7code;
    this.itemDetails.matrix8code = val.matrix8code;
    this.itemDetails.matrix9code = val.matrix9code;
    this.itemDetails.matrix10code = val.matrix10code;
  }

  rowClick(val) {
    if (this.stockrequest === "YES") {
      this.matrixSelected(val);
    } else {
      this.select(val);
    }
  }

  goNextforRequest() {
    this.dialogRef.close({
      matrix1code: this.itemDetails.matrix1code,
      matrix2code: this.itemDetails.matrix2code,
      matrix3code: this.itemDetails.matrix3code,
      matrix4code: this.itemDetails.matrix4code,
      matrix5code: this.itemDetails.matrix5code,
      matrix6code: this.itemDetails.matrix6code,
      matrix7code: this.itemDetails.matrix7code,
      matrix8code: this.itemDetails.matrix8code,
      matrix9code: this.itemDetails.matrix9code,
      matrix10code: this.itemDetails.matrix10code,
    });
  }

}
